import styled from 'styled-components'

export const AddCoProposerDropdownMenuWrapper = styled.div`
  position: absolute;
  border-radius: 8px;
  border: 1px solid rgba(32, 32, 32, 0.1);
  background: white;
  margin: 0;
  padding: 8px 0;
  max-height: 296px;
  min-width: 265px;
  z-index: 1000;
  top: 30px;
  box-shadow: 0px 2px 8px -2px rgba(32, 32, 32, 0.1);
`

export const AddCoProposerMenuItem = styled.div`
  height: 56px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  cursor: pointer;

  :hover {
    background: rgba(32, 32, 32, 0.05);
  }
`

export const AddCoProposerMenuItemIcon = styled.div`
  height: 32px;
  width: 32px;
  border-radius: 50%;
  margin-right: 16px;
  background: rgba(10, 161, 244, 1);
`

export const AddCoProposerMenuItemName = styled.div`
  line-height: 16px;
  font-size: 14px;
  font-weight: bold;
`

export const AddCoProposerMenuItemEmail = styled.div`
  line-height: 16px;
  font-size: 12px;
  font-weight: 300;
`

export const AddCoProposerChip = styled.div`
  background: ${(p) => {
    return p.userFound ? 'rgba(32, 32, 32, 0.05)' : 'rgba(225, 25, 0, 0.1)'
  }};
  border-radius: 4px;
  padding: 8px;
  padding-right: 12px;
  display: inline-block;
  align-items: center;
  margin: 4px;
  height: 32px;
  vertical-align: center;
  svg path {
    fill: rgba(32, 32, 32, 0.5);
  }
`

export const AddCoProposerWrapper = styled.div`
  position: relative;
  border-radius: 4px;
  border: 1px solid rgba(32, 32, 32, 0.2);
  display: block;
  min-height: 200px;
  padding-top: 4px;
  padding-bottom: 32px;
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
  margin-bottom: 16px;

  &:focus-within {
    border: 1px solid #0aa1f4;
    box-shadow: 0px 1px 2px rgba(32, 32, 32, 0.05), 0px 0px 0px 4px rgba(10, 161, 244, 0.1);
  }
`


export const AddCoProposerInput = styled.input`
  border: none;
  outline: none;
  margin: 8px;
  width: 194px;
`

export const AdditionalInfo = styled.div`
  position: absolute;
  bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
  color: rgba(32, 32, 32, 0.5);
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: space-between;
  width: 100%;
`
